import freeze from '@/helpers/freeze';
import { ICoverage, IDuration, ITemplate, ProductModel, Result } from '@/types/base';
import { AgGridRequest } from '@/types/models';
import CrudRequest from '../CrudRequest';
import { _Guid } from '../Guid';
import request from '../request';

class Product extends CrudRequest<ProductModel> {
    public async create(args: ProductModel): Promise<Result<ProductModel>> {
        return request(`/${this.entity}`, {
            method: 'POST',
            data: {
                ...args,
                serialCode: args.serialCode || '',
                serialSequence: args.serialSequence || '',
                productCategoryPath: args.productCategoryPath || '',
            },
        });
    }

    public async update(id: string, data: ProductModel): Promise<Result<ProductModel>> {
        return request(`/${this.entity}/${id}`, {
            method: 'POST',
            data: {
                ...data,
                serialCode: data.serialCode || '',
                serialSequence: data.serialSequence || '',
                productCategoryPath: data.productCategoryPath || '',
            },
        });
    }

    public async getCoveragesAg(params: AgGridRequest, id: _Guid): Promise<Result<ICoverage[]>> {
        return request(`/${this.entity}/ag/${id}/coverages`, {
            method: 'POST',
            data: params,
        });
    }

    public async getDurationsAg(params: AgGridRequest, id: _Guid): Promise<Result<IDuration[]>> {
        return request(`/${this.entity}/ag/${id}/durations`, {
            method: 'POST',
            data: params,
        });
    }

    public async getTemplatesAg(params: AgGridRequest, id: _Guid): Promise<Result<ITemplate[]>> {
        return request(`/${this.entity}/ag/${id}/templates`, {
            method: 'POST',
            data: params,
        });
    }

    public async getListOfNamesServicesAndSubservices(productId: string): Promise<
        Result<{
            services: string[];
            subServices: string[];
        }>
    > {
        return request(`/${this.entity}/list/${productId}/services-subservices`, {
            method: 'POST',
            data: {},
        });
    }
}

export default freeze(new Product('product')) as Product;
